@if (isLoadingData()) {
  <div class="movie-detail-section reasons-to-watch-skeleton">
    <ush-movie-detail-skeleton width="12rem" height="1.5rem" />
    <ush-movie-detail-skeleton width="100%" height="1rem" />
    <ush-movie-detail-skeleton width="90%" height="1rem" />
    <ush-movie-detail-skeleton width="78%" height="1rem" />
  </div>
} @else {
  <div class="movie-detail-section" *ngIf="movie()?.trReasonsToWatch">
    <div
      class="header-msg title reasons-to-watch-title"
      i18n-attr="@@movie.menu.reasonsToWatch"
      data-translate="movie.menu.reasonsToWatch"
      i18n="@@movie.menu.reasonsToWatch"
    >
      Reasons to watch
    </div>
    <div class="text reasons-to-watch-content" [innerHTML]="movie()?.trReasonsToWatch | safe: 'html'"></div>
  </div>
}
